import { render } from "./MenuUserDesktop.vue?vue&type=template&id=b0212256&scoped=true&ts=true"
import script from "./MenuUserDesktop.vue?vue&type=script&lang=ts"
export * from "./MenuUserDesktop.vue?vue&type=script&lang=ts"

import "./MenuUserDesktop.vue?vue&type=style&index=0&id=b0212256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0212256"]])

export default __exports__